/* eslint-disable object-shorthand */
import { useSelector } from 'react-redux';
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchLoggedUser } from '@/services/hooks';
import { FilterType } from '@/pages/Report';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const owner = queryKey[2];
  const filterValues = queryKey[3];

  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_report?owner=${owner}&from_date=${filterValues.fromDate}&to_date=${filterValues.toDate}&from_time=${filterValues.fromTime}&to_time=${filterValues.toTime}&company=${filterValues.company}&cost_center=${filterValues.costCenter}&payment_mode=${filterValues.paymentMode}&payment_detail=${filterValues.paymentDetail}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchSalesReport = (filter: FilterType) => {
  const { url } = useSelector(selectAuth);
  const { data } = useFetchLoggedUser();

  return useQuery(['sales-report', url, data, filter], fetcher, {
    enabled: !!data,
  });
};
